import React from "react";
import Logo from "../SVGs/Logo";
import styles from "./Footer.module.scss";
import assets from "../../assets";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Arrow from "../Arrow";

export default function Footer({ data }) {
  const { locale } = useParams();
  const { t } = useTranslation();

  const links = [
    {
      title: t("common.about"),
      link: "/about",
    },
    {
      title: t("common.projects"),
      link: "/projects",
    },
    {
      title: t("home.contactus"),
      link: "/contact",
    },
  ];
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.info}`}>
        <div className={styles.col}>
          <Logo />
          <div className={`container ${styles.copyrights}`}>
            <p>
              © {new Date().getFullYear()}, {t("common.copyrights")}
            </p>
            <div className={styles.socialMedia}>
              <a
                href={data?.facebook}
                target="_blank"
                referrerPolicy="no-referrer"
              >
                <img src={assets.icons.facebookIcon} alt="out facebook page" />
              </a>
              <a
                href={data?.linkedin}
                target="_blank"
                referrerPolicy="no-referrer"
              >
                <img src={assets.icons.linkedInIcon} alt="out linkedin page" />
              </a>

              <a
                href={data?.instagram}
                target="_blank"
                referrerPolicy="no-referrer"
              >
                <img src={assets.icons.instgramIcon} alt="out instgram page" />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.col}>
          <ul>
            {links.map((link, index) => {
              return (
                <li key={index}>
                  <a href={`/${locale}${link.link}`}>{link.title}</a>
                </li>
              );
            })}
          </ul>
          <div className={styles.phone}>
            <div className={styles.contactPhone}>
              <p>
                {data?.phone}
              </p>
              {
                data?.phone2 &&
                <>
                  <span>
                    |
                  </span>
                  <p>
                    {data?.phone2}
                  </p>
                </>
              }
            </div>

            <p>{data?.email}</p>
          </div>
        </div>
      </div>
      <button
        onClick={() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }}
        className={styles.upArrow}
      >
        <Arrow color={"#5E8A4A"} />
      </button>
    </footer>
  );
}
